export const isQA = process.env.CONFIG_ENV == 'qa';
export const isDev = process.env.CONFIG_ENV == 'dev';
export const isProd = process.env.CONFIG_ENV == 'prod';
